// types
import { FieldSource } from 'types/graphql'

export enum RiskFilterTypes {
  ME = 'ME',
  BUSINESS_UNITS = 'MY BUSINESS UNIT'
}

export enum RiskSpecialRelatedTypes {
  LINK_TO_BUSINESS_UNIT = 'LINK_TO_BUSINESS_UNIT',
  LINK_TO_USER_POSITION = 'LINK_TO_USER_POSITION',
  LINK_TO_PARENT_POSITION = 'LINK_TO_PARENT_POSITION',
  LINK_TO_REPORTS_TO_PERSON = 'LINK_TO_REPORTS_TO_PERSON',
  LINK_TO_USER_ASSIGNED_TO_POSITION = 'LINK_TO_USER_ASSIGNED_TO_POSITION'
}

export const relatedTypesBySource: Record<string, RiskSpecialRelatedTypes[]> = {
  [FieldSource.Users]: [
    RiskSpecialRelatedTypes.LINK_TO_REPORTS_TO_PERSON,
    RiskSpecialRelatedTypes.LINK_TO_USER_ASSIGNED_TO_POSITION
  ],
  [FieldSource.Positions]: [
    RiskSpecialRelatedTypes.LINK_TO_USER_POSITION,
    RiskSpecialRelatedTypes.LINK_TO_PARENT_POSITION
  ],
  [FieldSource.BusinessUnits]: [RiskSpecialRelatedTypes.LINK_TO_BUSINESS_UNIT]
}

export const RiskSpecialRelatedTypesText = {
  [RiskSpecialRelatedTypes.LINK_TO_BUSINESS_UNIT]: 'Link to business unit',
  [RiskSpecialRelatedTypes.LINK_TO_USER_POSITION]: 'Link to user position',
  [RiskSpecialRelatedTypes.LINK_TO_PARENT_POSITION]: 'Link to parent position',
  [RiskSpecialRelatedTypes.LINK_TO_REPORTS_TO_PERSON]: 'Link to reports to person',
  [RiskSpecialRelatedTypes.LINK_TO_USER_ASSIGNED_TO_POSITION]: 'Link to user assigned to position'
}
